#import "../fragments/multi-page-form-fragment.graphql"

query GetMultiPageForm($formId: ID, $formSlug: String) {
    form(id: $formId, slug: $formSlug) {
        ...MultiPageFormFragment
    }
}
